import { render, staticRenderFns } from "./CustomerItemTable.vue?vue&type=template&id=629f3fe1&"
import script from "./CustomerItemTable.vue?vue&type=script&lang=js&"
export * from "./CustomerItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports